import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-themify-icons',
	templateUrl:'./ThemifyIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./ThemifyIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ThemifyIconsPluginCompPage
{
	mdContent_1113 = `\`\`\`java
import com.jwebmp.plugins.themify.icons.ThemifyIcons;
\`\`\``;
	mdContent_1114 = `\`\`\`java
// ThemifyIcons.arrow_right.toString() returns "ti-arrow-right"
\`\`\``;
}
